import React from 'react';
import { Helmet } from 'react-helmet';

const LocalBusinessRichSnippet = (): JSX.Element => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'LocalBusiness',
        name: 'Rapid Formations',
        url: 'https://www.rapidformations.co.uk/',
        image: 'https://d2zkzcdiu38fde.cloudfront.net/images/d6562275-aa8a-45ac-a4e3-8c40e9716329.png',
        description:
          "Quick and easy company registration from the UK's leading company formation agent. Form your company with our simple 4 step process.",
        address: {
          '@type': 'PostalAddress',
          streetAddress: '71-75, Shelton Street',
          addressLocality: 'London',
          addressRegion: 'Covent Garden',
          postalCode: 'WC2H 9JQ',
          addressCountry: 'United Kingdom',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: '',
          longitude: '',
        },
        hasMap: '',
        telephone: '',
      })}
    </script>
  </Helmet>
);

export default LocalBusinessRichSnippet;
